__turbopack_context__.v({
  "fade": "UIButton-module-scss-module__zLlBpG__fade",
  "fade-slide": "UIButton-module-scss-module__zLlBpG__fade-slide",
  "fullWidth": "UIButton-module-scss-module__zLlBpG__fullWidth",
  "iconLeft": "UIButton-module-scss-module__zLlBpG__iconLeft",
  "iconOnly": "UIButton-module-scss-module__zLlBpG__iconOnly",
  "iconRight": "UIButton-module-scss-module__zLlBpG__iconRight",
  "open-from-center": "UIButton-module-scss-module__zLlBpG__open-from-center",
  "primary": "UIButton-module-scss-module__zLlBpG__primary",
  "secondary": "UIButton-module-scss-module__zLlBpG__secondary",
  "spin": "UIButton-module-scss-module__zLlBpG__spin",
  "tertiary": "UIButton-module-scss-module__zLlBpG__tertiary",
  "text": "UIButton-module-scss-module__zLlBpG__text",
  "tonal": "UIButton-module-scss-module__zLlBpG__tonal",
  "ui-button": "UIButton-module-scss-module__zLlBpG__ui-button",
});
